export function createRating(avg, isShowDetailOnHover) {
  let isShowDetail = isShowDetailOnHover && !(navigator.maxTouchPoints || 'ontouchstart' in document.documentElement);

  let numberAvg = Number(avg)
  if(isNaN(Number(avg))){
    return ''
  }
  let result = htmlStarList(numberAvg);

  return `
    <div class="alr-wrapper-rating${isShowDetail && numberAvg > 0 ? ' has-detail': ''}">
      ${result}
      ${ isShowDetail && numberAvg > 0 ?
      `<svg style="margin-left: 6px;" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5859 1.4375L10.1406 0.96875C10.0234 0.851562 9.83594 0.851562 9.74219 0.96875L5.5 5.21094L1.23438 0.96875C1.14062 0.851562 0.953125 0.851562 0.835938 0.96875L0.390625 1.4375C0.273438 1.53125 0.273438 1.71875 0.390625 1.83594L5.28906 6.73438C5.40625 6.85156 5.57031 6.85156 5.6875 6.73438L10.5859 1.83594C10.7031 1.71875 10.7031 1.53125 10.5859 1.4375Z" fill="#6E6E6E"/>
      </svg>` : ''}
    </div>`;
}

export function htmlStarList(numberAvg) {
  let result = '',
    arr = [];

  if(numberAvg <= 0){
    arr = [0, 0, 0, 0, 0]
  }else if(numberAvg <= 1){
    arr = [numberAvg, 0, 0, 0, 0]
  }else if(numberAvg <= 2){
    arr = [1, (numberAvg - 1), 0, 0, 0]
  }else if(numberAvg <= 3){
    arr = [1, 1, (numberAvg - 2), 0, 0]
  }else if(numberAvg <= 4){
    arr = [1, 1, 1, (numberAvg - 3), 0]
  }else if(numberAvg <= 5){
    arr = [1, 1, 1, 1, (numberAvg - 4)]
  }
  arr.map(item => {
    result += htmlIconRating(item)
  })

  return result;
}

function htmlIconRating(number) {
  let styleWidth = 'auto'
  let visibilitySymbolBg = 'hidden'
  if(number == 1){
    styleWidth = 'auto'
  }else if(number == 0){
    styleWidth = '0px'
    visibilitySymbolBg = 'visible'
  }else{
    styleWidth = parseInt(number * 100) + '%'
    visibilitySymbolBg = 'visible'
  }
  let htmlIcon = `
  <div class="alr-rating-symbol">
    <div class="alr-rating-symbol-background alr-icon-star" style="visibility: ${visibilitySymbolBg};"></div>
    <div class="alr-rating-symbol-foreground" style="width: ${styleWidth};">
      <span class="alr-icon-star">
      </span>
    </div>
  </div>`;
  return htmlIcon;
}
